import { Component } from '@angular/core';

import { ApiCallCachingService } from '../../services/api-call-caching.service';

import { DropdownBaseComponent } from './dropdown-base/dropdown-base.component';

import { EFileValidationDisplayStatus } from '../../models/efile-validation-status.model';

import { Observable } from 'rxjs';

@Component({
    selector: 'spv2-efile-validation-status-dropdown',
    templateUrl: './dropdown-base/dropdown-base.component.html',
    styleUrls: ['./dropdown-base/dropdown-base.component.scss'],
    standalone: false
})
export class EFileValidationStatusDropdownComponent extends DropdownBaseComponent<void, EFileValidationDisplayStatus> {

  uniqueName = "efileValidationStatus";

  textField = "name";
  valueField = "status";

  valuePrimitive = false;
  enableCache = true;

  dataFunction = () => {
    return new Observable<EFileValidationDisplayStatus[]>(x => {
      x.next(EFileValidationDisplayStatus.allVisibleInFilter);
      x.complete();
    })
  };

  constructor(cachingService: ApiCallCachingService) {
    super(cachingService);
  }

}
